import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { logError } from 'commons/logger';
import { getAnalyticsDataFromCartItem } from 'components/consumer/cart/utils';
import { useEffect } from 'react';
import useMetaFormattedCityStateZip from '../useMetaFormattedCityStateZip';

const DEFAULT_PRODUCTS = [];

const useJbEventFBCheckout = (products = DEFAULT_PRODUCTS) => {
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state,
  } = useMetaFormattedCityStateZip();
  useEffect(() => {
    const analyticsProducts = products?.map(getAnalyticsDataFromCartItem);
    const skus = analyticsProducts?.map(product => product.sku);
    const totalPrice = analyticsProducts?.reduce(
      (acc, product) => acc + product.discountPrice,
      0
    );

    window.jbEventFBCheckout = () => {
      if (products?.length > 0) {
        sendFBEvent(FB_EVENTS.CHECKOUT, {
          content_ids: skus,
          content_type: 'product',
          currency: 'USD',
          value: totalPrice,
          zp: zip,
          ct: city,
          st: state,
        });
      } else {
        logError(new Error('window.jbEventFBCheckout: products.length < 1'));
      }
    };
  }, [city, products, state, zip]);
};

export default useJbEventFBCheckout;
